// extracted by mini-css-extract-plugin
module.exports = {"Content":"App_Content__W4TAC","Main":"App_Main__1uaKB"};